import React, {useState, useEffect, useCallback} from 'react';
import {Outlet, useLocation} from 'react-router-dom';
import ErrorBoundary from '../ErrorBoundary';
import Header from '../header';
import RestaurantClosed from '../restaurantClosed';
import TopBar from '../topBar/TopBar';
import CategoriesBar from '../CategoriesBar';
import Loyalty from '../loyalty/Loyalty';
import QrCode from '../QrCode';
import Footer from '../footer/footer'
import RegistrationCard from '../../modals/registrationCard'
import Prompt from '../../modals/prompt'
import VerificationCode from '../../modals/verificationCode'
import { inject, observer } from "mobx-react";
import "./Home.css";
import MessagingBtn from '../../buttons/messagingBtn';
import BottomNav from '../bottomNav';
import _useTranslate from '../../hooks/_useTranslate';

const Home = ({feathersStore})=> {

  let common = _useTranslate(feathersStore.language, "common");

  const location = useLocation();

  useEffect(() => { //end the pre-order session live when the booking hour arrives
    const check = () => {
      const po = feathersStore.preOrderBooking;
      if(po?.deferredTime && new Date(po.deferredTime) <= new Date()){
        if(feathersStore.tableId === po.tableId){
          feathersStore.setTableId('eshop');
          //tombstone (valid 'eshop' entry) instead of removeItem: a SECOND tab still in table
          //mode in memory adopts it on its next cart/checkout mount (valid key wins) — a bare
          //removal would let that tab resurrect the ended session via the live-session rule.
          try{ localStorage.setItem('tableId', JSON.stringify({ value: 'eshop', expiry: new Date().getTime() + 6 * 60 * 60 * 1000 })); }catch(e){}
        }
        feathersStore.setPreOrderBooking(null);
      }
    };
    check();
    const timer = setInterval(check, 60000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {   
    const cart = localStorage.getItem('fdwa_cart');
    cart && feathersStore
      .setCartLength(JSON.parse(localStorage.getItem('fdwa_cart'))?.length || 0);
  }, [])  

  const [visiblePrompt, setVisiblePrompt] = useState(false);
  const [visibleRegister, setRegistrationModal] = useState(false);
   
  const togglePrompt = ()=> {  
    setVisiblePrompt(oldValue => !oldValue);      
  }

  const openRegistrationModal = ()=> {
    setVisiblePrompt(false);
    setRegistrationModal(true);
  }

  const closeRegistrationModal = ()=> {
    setRegistrationModal(false);
  }

  //The code screen is the store's pendingSignup (feathersStore.js says why), so the checkout's 'register here'
  //shows the same one, here, where the sign-out registration does cannot unmount it.
  const openVerification = pload => {
    setRegistrationModal(false);
    feathersStore.setPendingSignup(pload);
  }

  const closeVerification = ()=> {
    feathersStore.setPendingSignup(null);
  }

  const clickEnter = ()=> {      
    setVisiblePrompt(false)
  }  
  
  return(
    
    <div className={"app-base" + (!feathersStore.restaurantOpen  
       && feathersStore.showRestaurantMessage ? " app-base-restaurant-closed" : "")}>
      <a className="skip-link" href="#main-content">{common.skipToContent || "Skip to content"}</a>
      { Object.keys(feathersStore?.settings)?.length > 0 &&
        <>  
          <Prompt 
            visible={visiblePrompt}      
            close={togglePrompt}
            onClickEnter={clickEnter}
            onClickAway={togglePrompt}
            onClickRegister={openRegistrationModal}      
            />
          <RegistrationCard
            visible={visibleRegister} 
            close={closeRegistrationModal}
            onClickAway={closeRegistrationModal}
            onClick={openVerification}
          />
        </>
      }
          
      <VerificationCode
        visible={!!feathersStore.pendingSignup}
        onClickCloseCode={closeVerification}
        payload={feathersStore.pendingSignup}
      />  
      {!feathersStore.restaurantOpen && feathersStore.showRestaurantMessage ? <RestaurantClosed/> : null}     
      <Header />   
      <TopBar onClickSignIn={()=> togglePrompt()}/>    
      <CategoriesBar/>
      <Loyalty/>
      {feathersStore.preOrderBooking && feathersStore.tableId !== 'eshop' &&
        <div style={{
          backgroundColor: 'var(--surface-alt)', color: 'var(--main-text-color)', textAlign: 'center',
          padding: '8px 12px', fontWeight: 600, fontSize: '0.95rem',
          borderBottom: '1px solid var(--border-color)'
        }}>
          {(common.orderingForBooking || "You are ordering for your reservation")}
          {" - "}
          {String(feathersStore.preOrderBooking.bookingDay).split('-').reverse().join('/')}
          {" "}{feathersStore.preOrderBooking.bookingHour}
        </div>
      }
      <main id="main-content" className="app-main">
        <ErrorBoundary
          resetKey={location.pathname}
          title={common.errorTitle}
          message={common.errorMessage}
          retryLabel={common.tryAgain}
          homeLabel={common.goToHome}
        >
          <Outlet/>
        </ErrorBoundary>
      </main>
      {feathersStore.showAppDownload() && <QrCode/>}
      <Footer/>  
      <div className="messaging-btn-container">
        <MessagingBtn/>
      </div>
      <BottomNav/>
    </div>
   
  )
}

export default inject('feathersStore')(observer(Home));